define.alias("shared/components/shared/wizards/carousel/step-one", "settings/components/shared/wizards/carousel/step-one");